import ModalContainerModule from "../../../modules/modalContainer"

export default function ViewExpiringLeaseModal(props) {
    /**
     *
     * REQUIRED PROPS
     *
     * handleAccept: func()
     * handleClose: func()
     * open: boolean
     *
     */

    return (
        <ModalContainerModule
            size="sm"
            accept={props.handleAccept}
            cancel={props.handleClose}
            openModal={props.open}
            modalTitle="View Expiring Lease"
            acceptButtonText="OK"
        ></ModalContainerModule>
    )
}
